import { render, staticRenderFns } from "./OrmBatchingAvailableQuotes2.vue?vue&type=template&id=1033601d&scoped=true"
import script from "./OrmBatchingAvailableQuotes2.vue?vue&type=script&lang=js"
export * from "./OrmBatchingAvailableQuotes2.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingAvailableQuotes2.vue?vue&type=style&index=0&id=1033601d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033601d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1033601d')) {
      api.createRecord('1033601d', component.options)
    } else {
      api.reload('1033601d', component.options)
    }
    module.hot.accept("./OrmBatchingAvailableQuotes2.vue?vue&type=template&id=1033601d&scoped=true", function () {
      api.rerender('1033601d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingAvailableQuotes2.vue"
export default component.exports